// extracted by mini-css-extract-plugin
export default {"wrapper":"unloadingTemplate_wrapper__PGbW9"};